var map = {
	"./ar/pages/statistics/sales.js": "3f37",
	"./de/pages/statistics/sales.js": "1345",
	"./en/pages/statistics/sales.js": "0524",
	"./es/pages/statistics/sales.js": "9bb0",
	"./fr/pages/statistics/sales.js": "cfe4",
	"./ja/pages/statistics/sales.js": "1e35",
	"./pt/pages/statistics/sales.js": "3957",
	"./ru/pages/statistics/sales.js": "d678",
	"./tr/pages/statistics/sales.js": "9942"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "878b";